import React, { useState } from 'react'
import WelcomeCouponBanner from 'components/TeamPublicPage/WelcomeCouponBanner'
import LoginModal from 'components/TeamPublicPage/LoginModal'
import { generateColorSystem } from 'utils/colorUtils'

// Wrapper that pairs the welcome-coupon pill with the existing login modal for
// the community pages (the public team page already renders the banner inside its
// own app). Holds the login-modal state; the pill is suppressed while the login
// modal is open so it does not float over its own modal. Contains NO mount /
// createRoot logic — mounting lives in pages/mountWelcomeCoupon.js.
export default function WelcomeCouponMount({ team, currentUser, teamSlug, translations, brandColor, welcomeCouponClaimable }) {
  const [showLoginModal, setShowLoginModal] = useState(false)

  // Match the public page's per-team branding (generateColorSystem falls back to
  // the brand default when brandColor is nil). LoginModal uses this for its
  // no-logo fallback tile gradient.
  const colors = generateColorSystem(brandColor)

  return (
    <>
      <WelcomeCouponBanner
        team={team}
        currentUser={currentUser}
        teamSlug={teamSlug}
        translations={translations}
        claimable={welcomeCouponClaimable}
        onClaim={() => setShowLoginModal(true)}
        suppressed={showLoginModal}
      />
      <LoginModal
        isOpen={showLoginModal}
        onClose={() => setShowLoginModal(false)}
        teamLogo={team?.logo_url}
        teamName={team?.name}
        colors={colors}
        translations={translations}
      />
    </>
  )
}
